<template>
	<div class="row">
		<div class="col-12 text-center" v-if="!item">
			<div class="spinner-grow" role="status">
				<span class="sr-only">Loading...</span>
			</div>
		</div>

		<!-- main toolbar -->
		<div class="col-12" v-if="item">
			<div class="card"><div class="card-body">
				
			</div></div>
		</div>

		<div class="col-md-12 col-lg-3" v-if="item">
			<div class="card">
				<div class="card-body">
					<div class="form-group">
						<label>Логин</label>
						<input type="text" v-model="item.login" class="form-control">
					</div>

					<div class="form-group">
						<label>Пароль</label>
						<input type="password" v-model="item.password" class="form-control">
					</div>

					<div class="form-group">
						<label>Роль</label>
						<select class="form-control" v-model="item.role">
							<option v-for="(value, key) in app_mongo_desc.userRoleDescription.roles" :key="key" :value="key">{{ value }}</option>
						</select>
					</div>

					<div class="form-group">
						<label>Проверять IP сессии</label><br>

						<input type="checkbox" id="switch_show" v-model="item.checkIP" data-switch="success"/>
						<label for="switch_show" data-on-label="Да" data-off-label="Нет"></label>
					</div>

					<button v-if="!loading"  type="submit" class="btn btn-primary" @click.prevent="editItem()">Сохранить</button>
					<button v-else class="btn btn-primary" type="button" disabled>
						<span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
						Отправка данных...
					</button>

				</div>
			</div>
		</div>

		<div class="col-md-12 col-lg-3" v-if="item">
			<div class="card">
				<div class="card-body">
					<h3>
						Телеграм бот
						<a href="https://tgrm.cc/labodinaws_bot" class="btn btn-outline-info btn-sm btn-rounded" target="_blank">Установить бота</a>
					</h3>

					<div v-if="!item.telegram.token">
						<h4>1. Установить бота и получить код для активации</h4>
						<p>Ссылка на бота сверху. При установке нужно нажать на кнопку Start в телеграме</p>
						<button class="btn btn-success btn-sm" @click="setTelegramToken()">Получить код</button>
					</div>

					<div v-if="item.telegram.token && !item.telegram.user_id">
						<h4>2. Отправьте боту всё сообщение снизу со словом token</h4>
						<span>token: {{ item.telegram.token }}</span><br><br>
						<button class="btn btn-success btn-sm" @click="getItem()">Отправил</button>
					</div>

					<div v-if="item.telegram.token && item.telegram.user_id">
						<h4>3. Выберите на какие оповещения хотите подписаться</h4>

						<div class="form-group">
							<label for="example-multiselect">Каналы, через shift можно выбрать несколько</label>
							<select id="example-multiselect" multiple class="form-control" v-model="item.telegram.channels">
								<option v-for="(value, key) in app_mongo_desc.userRoleDescription.telegram_channels" :key="key" :value="key">{{ value }}</option>
							</select>
						</div>

						<button v-if="!loading"  type="submit" class="btn btn-primary" @click.prevent="editItem()">Сохранить</button>
						<button v-else class="btn btn-primary" type="button" disabled>
							<span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
							Отправка данных...
						</button>

					</div>
				</div>
			</div>
		</div>

		<div class="col-md-12 col-lg-6" v-if="item">
			<div class="card">
				<div class="card-body">
					<h3>Список сессий</h3>

					<table class="table table-striped table-centered table-responsive-md">
						<thead>
							<tr>
								<th>ip</th>
								<th>location</th>
								<th>expire</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(session, i) in item.sessions">
								<td>{{ session.ip }}</td>
								<td>{{ session.city ? session.city : '?' }} / {{ session.country ? session.country : '?' }}</td>
								<td>{{ formatTimeDiff(session.expiresAt) }}</td>
								<td>
									<button class="btn btn-sm btn-danger btn-rounded" @click="deleteSession(session._id)">delete</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import log from '@/plugins/log'
import { to } from '@/plugins/utils'

export default {
	name: 'UserAdd',
	data: () => {
		return {
			item: null,
			loading: false
		}
	},
	computed: {
		...mapState([
			'app_mongo_desc',
			'app_ts'
		]),
		id() {
			return this.$route.params.id
		},
	},
	async beforeMount() {
		await this.getItem()
	},
	mounted() {
		log.debug(`/views/user/edit/${this.id}`, 'mounted')
	},
	methods: {
		async getItem() {
			var [err, response] = await to( this.$http.get(`/user/edit/${this.id}`) )
			if(err) {
				log.error(`/views/user/edit/${this.id}`, 'methods.getItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			if(!response.data.success) {
				log.error(`/views/user/edit/${this.id}`, 'methods.getItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}

			log.debug('/views/user/add', 'methods.getItem', '$http.request', response.data)
			response.data.item.password = ''

			this.item = response.data.item
		},

		async editItem() {
			this.loading = true
			var [err, response] = await to( this.$http.post(`/user/edit/${this.id}`, this.item) )
			if(err) {
				this.loading = false
				log.error(`/views/user/edit/${this.id}`, 'methods.editItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			if(!response.data.success) {
				this.loading = false
				log.error(`/views/user/edit/${this.id}`, 'methods.editItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}

			this.loading = false
			log.debug(`/views/user/edit/${this.id}`, 'methods.editItem', '$http.request', response.data)
			$.NotificationApp.send("Успешно", '', "top-right", "", "success")


			this.getItem()
		},

		async deleteSession(id) {
			if(!confirm('Уверены, что хотите удалить?')) return;
			
			var [err, response] = await to( this.$http.post(`/session/delete/${id}`) )
			if(err) {
				log.error(`/views/user/edit/${this.id}`, 'methods.deleteSession', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			if(!response.data.success) {
				log.error(`/views/user/edit/${this.id}`, 'methods.deleteSession', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}

			log.debug(`/views/user/edit/${this.id}`, 'methods.deleteSession', '$http.request', response.data)
			$.NotificationApp.send("Успешно", '', "top-right", "", "success")

			this.getItem()
		},

		setTelegramToken() {
			this.item.telegram.token = this.makeid(12)
			this.editItem()
		},

		formatTimeDiff(ts) {
			let diff = ts - this.app_ts;
			if (diff <= 60) return `${diff} sec`;
			if (diff <= 3600) {
				diff = parseInt(diff / 60);
				return `${diff} min`;
			}
			if (diff <= 3600 * 24) {
				diff = parseInt(diff / 3600);
				return `${diff} h`;
			}
			if (diff <= 3600 * 24 * 30) {
				diff = parseInt(diff / 3600 / 24);
				return `${diff} d`;
			}
			if (diff <= 3600 * 24 * 30 * 12) {
				diff = parseInt(diff / 3600 / 24 / 30);
				return `${diff} m`;
			}

			diff = parseInt(diff / 3600 / 24 / 30 / 12);
			return `${diff} y`;
		},

		makeid(length) {
			var result           = '';
			var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			var charactersLength = characters.length;
			for ( var i = 0; i < length; i++ ) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength));
			}
			return result;
		}
	}
};
</script>